/* SLIDER */
$('.trynow-slider-slick').slick({
  arrows: false,
  dots: true,
});

/* ELEMENTS INTERACTION */
$(".original-button").on("click", function () {
    $('#properties').val("false");
})

$(".trynow-button").on("click", function () {
    $('#properties').val("true");
});

$("select.single-option-selector-product-template").change(function(){
  	tryNowButtonChange();
});

/* CART PAGE CHANGES */
function tryNowButtonChange(){
  var value = $('#SingleOptionSelector-1').val();
  if(($(".original-button").css('background-color') == 'rgb(29, 185, 84)' ) && value == 'pleaseselect'){
    $(".trynow-container").hide();
    $(".trynow-button").prop( "disabled", true );
  }else{
    $(".trynow-container").show();
    $(".trynow-button").prop( "disabled", false );
  }
}

/* UPSELLS CHANGE */
function changeUpsellsTN(formData){
	console.log("Change Upsells");
  	
  	formData.forEach(function(data){
      console.log(data);
      if(data.name == "properties[TryNow]" ){
        if(data.value == "true"){
          $('.revy-upsell-target-option:contains("TryNow")').html('<span class="revy-upsell-target-option-bullet">-</span> TRY HOME FOR FREE');
          getCart(true);
        }else{
          $('.revy-upsell-target-option:contains("TryNow")').remove();
          getCart(true);
        }
      }
    })
}

function getCart(first_time){
  let cart_total = 0;
  let trynow_total = 0;
  $.ajax({
    type: "GET",
    url: "https://jaxxon.com/cart.js",
    success: function(cart) {
      trynow_total = getTryNowItems(cart.items);
      cart_total = cart.total_price;
      if(trynow_total > 0){
        $(".revy-upsell-cart-summary-total-item").text("("+cart.item_count+" items)")
        $('.revy-upsell-cart-summary-total-value-final').text("$" + ((cart_total-trynow_total)/100) + " ($" + cart_total/100 + " if kept)");
        $('.revy-upsell-btn-checkout').replaceWith('<a href="https://jaxxon.trynowcheckout.com/customer-information?shop=jaxxon.com&amp;token='+cart.token+'" class="upsells_checkout_button" style="text-align: center !important; padding-top: 5px !important; padding-bottom: 5px !important; border-radius: 3px !important; cursor: pointer !important; all: initial; display: block; width: 100%; background: #fff; color: #1e2028; -webkit-text-fill-color: #1e2028; font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif; font-weight: 400!important; text-rendering: optimizeLegibility; border-bottom: 2px solid rgba(0,0,0,.1); -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; box-shadow: none; background-color: var(--checkout-background-color)!important; color: var(--checkout-font-color)!important; -webkit-text-fill-color: var(--checkout-font-color)!important; width: auto; margin-bottom: 10px!important; box-shadow: 0 0 3px rgba(0,0,0,.11);">CHECKOUT</a>');
      	getProducts(first_time);
        
      }else{
        $('.revy-upsell-btn-checkout').replaceWith('<a name="checkout" href="https://jaxxon.com/checkout" class="revy-upsell-btn-checkout">CHECKOUT</a>');
      }
    },
    error: function(error){
      console.log("error");
    },
    cache: false,
    dataType: "json"
  })
}

function getTryNowItems(items){
  let try_now_price = 0;
  items.forEach(item => {
    if (item.properties !== null && item.properties !== undefined) {
      if (item.properties.hasOwnProperty("TryNow")) {
        if (item.properties.TryNow === "true") {
          try_now_price += (item.price * item.quantity);
        }
      }
    }
  });
  return try_now_price;
}

var products_db = {};

function getProducts(first_time){
 
  let products_in_upsells = $(".revy-upsell-offer-product-details-wrapper>a");
	
  products_in_upsells.each(function() {
   
    let product_link = $(this).attr("href");
    $.ajax({
      type: "GET",
      url: "https://jaxxon.com/"+product_link+".json",
      success: function(product){
         console.log('testing');
        product.product.variants.forEach(variant => {
          products_db[(product.product.id+variant.option1 + variant.option2).replace(/\s/g,'')] = variant.id;
        })
        changeButtonsUpsells(product, product_link, first_time);
      },
      error: function(error){
      	console.log(error);
      },
      cache: false,
      dataType: "json"
    });
  })
}

function changeButtonsUpsells(product, product_link, first_time){
  let is_product_trynow = product.product.tags.includes("trynow");
  var selector =  $(".revy-upsell-offer-product-details-wrapper>a[href='"+product_link+"']");
  if(is_product_trynow){
    if(first_time  && !selector.siblings(".revy-upsell-offer-product-price").children(".revy-upsell-offer-product-price-compare-percentage").length > 0){
    	let item_price = selector.siblings(".revy-upsell-offer-product-price").text();
    	selector.siblings(".revy-upsell-offer-product-price").children(".revy-upsell-offer-product-price-original").text("$0 (" + item_price + " if kept)");
    }
    if(selector.siblings(".revy-upsell-offer-product-price").children(".revy-upsell-offer-product-price-compare-percentage").length > 0){
      	let item_price = selector.siblings(".revy-upsell-offer-product-price").children('.revy-upsell-offer-product-price-original').text();
    	selector.siblings(".revy-upsell-offer-product-price").children(".revy-upsell-offer-product-price-original").children(".money").text("$0 (" + item_price + " if kept)");
    	selector.siblings(".revy-upsell-offer-product-price").children(".revy-upsell-offer-product-price-compare-percentage").remove();
    } 
    if(selector.parents(".revy-upsell-offer-product-details").siblings(".revy-upsell-offer-product-btn-wrapper").children(".revy-upsell-offer-product-btn").is(":enabled")){
    	selector.parents(".revy-upsell-offer-product-details").siblings(".revy-upsell-offer-product-btn-wrapper").children(".revy-upsell-offer-product-btn").replaceWith('<button type="button" class="upsells-trynow-button" id="'+ product.product.id +'" onclick="addToCartUpsellsTN(\''+product.product.id+'\')" style="margin-right: -12px !important; font-size: 14px !important; cursor: pointer !important; border-radius: 2px !important; all: initial; display: block; width: 100%; background: #fff; color: #1e2028; -webkit-text-fill-color: #1e2028; font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif; font-weight: 400!important; text-rendering: optimizeLegibility; border-bottom: 2px solid rgba(0,0,0,.1); -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; box-shadow: none; width: auto; color: #fff; -webkit-text-fill-color: #fff; font-weight: 600!important; background-image: none!important; text-transform: unset; background-color: var(--add-to-cart-background-color)!important; color: var(--add-to-cart-font-color)!important; -webkit-text-fill-color: var(--add-to-cart-font-color)!important; padding: 9px 12px!important;">TRY HOME FOR FREE</button>')
    } 
  }
}

function addToCartUpsellsTN(product_id){
  let material = $("#"+product_id).parents(".revy-upsell-offer-product-btn-wrapper").siblings(".revy-upsell-offer-product-details").find('.revy-upsell-offer-product-details-wrapper > div > .revy-upsell-offer-product-variants > select[data-position="1"]').children("option:selected").val();
  let chain_length = $("#"+product_id).parents(".revy-upsell-offer-product-btn-wrapper").siblings(".revy-upsell-offer-product-details").find('.revy-upsell-offer-product-details-wrapper > div > .revy-upsell-offer-product-variants > select[data-position="2"]').children("option:selected").val();
  let variant_id = products_db[product_id+material.replace(/\s/g,'')+chain_length.replace(/\s/g,'')];
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js?id="+variant_id+"&quantity=1&properties[TryNow]=true",
    dataType: "json",
    success: function(data, textStatus, xhr) {
      $("#"+product_id).text("PRODUCT ADDED");
      let message_time = setTimeout(function(){$("#"+product_id).text("TRY HOME FOR FREE");}, 1000)
      getCart(false);
    }
  })
}

function tryNowToken(){
  $.getJSON('/cart.js', function(cart) {
    $('.trynow_cart_page_checkout_button').attr('href', "https://jaxxon.trynowcheckout.com/customer-information?shopName=jaxxon.com&token=" + cart.token);
  });
}

/* RUN FUNCTIONS */
$(window).load(function() {
	tryNowButtonChange();
  	tryNowToken();
});
